import EmployeeTable from "./employess-table";

const EmployeeScreen = () => {
  return (
    <div className="content-area">
      <EmployeeTable />
    </div>
  );
};

export default EmployeeScreen;
